import { gql } from '@apollo/client';

export const GRAPHQL_LISTAR_PERFIL = gql`
    query perfil {
        perfil {
            id
            nome
            administrador
        }
    }
`;

export const GRAPHQL_MINHAS_ACOES = gql`
    query minhasAcoes {
        minhasAcoes {
            administrador
            acoes
        }
    }
`;

export const GRAPHQL_CATALOGO_ACOES = gql`
    query catalogoAcoes {
        catalogoAcoes {
            id
            titulo
            link
            acoes {
                id
                titulo
                chave
            }
        }
    }
`;

export const GRAPHQL_PERFIL_ACOES = gql`
    query perfilAcoes {
        perfil {
            id
            nome
            administrador
            acoes
        }
    }
`;

export const GRAPHQL_SALVAR_ACOES_PERFIL = gql`
    mutation salvarAcoesPerfil($perfilId: Int!, $acoes: [String!]!) {
        salvarAcoesPerfil(perfilId: $perfilId, acoes: $acoes)
    }
`;
